import React from 'react'
export function Hamburger() {
  return (
    <svg width="18" height="9" viewBox="0 0 18 9" fill="none" xmlns="http://www.w3.org/2000/svg">
      <line y1="0.5" x2="18" y2="0.5" stroke="currentColor" />
      <line y1="8.5" x2="18" y2="8.5" stroke="currentColor" />
    </svg>
  )
}
